import React, { useEffect, useState } from 'react';
import {
  Button,
  FormatText,
  FormCheckbox,
  FormInput,
  FormSelect,
  FormSubmitButton,
  MasterDetailForm,
  Row,
  Widget,
} from '@digital/ui';
import { Modal, Tooltip } from 'antd';
import { substituirAnexo } from '@app/api/demanda';
import { hasPermission } from '@app/helpers/permissions';
import { UploadFile } from '@app/components';

interface PropsModal {
  onUpdate: any;
  record: any;
}

const ModalSubstituirAnexo = (props: PropsModal) => {
  const { onUpdate, record } = props;
  const [exibirModal, setExibirModal] = useState(false);
  const [arquivo, setArquivo] = useState<boolean>(true);

  const handleSubmit = (values: any) => {
    substituirAnexo({
      justificativa: values.justificativa,
      arquivo: values.arquivo,
      id: record.id,
    }).then(data => {
      if (data.valid) {
        onUpdate();
        setExibirModal(false);
      }
    });
  };

  return (
    <>
      <Tooltip title="Substituir">
        <Button
          icon="ui-upload"
          // style={{ float: 'right' }}
          onClick={() => {
            setExibirModal(true);
            // CarregarDados();
          }}
        />
      </Tooltip>
      <Modal
        title="SUBSTITUIR ANEXO"
        // className="chat-modal"
        width="860px"
        visible={exibirModal}
        onCancel={() => {
          setExibirModal(false);
        }}
        footer={null}>
        {exibirModal && (
          <MasterDetailForm
            initialValues={{}}
            key="formSubstituirAnexo"
            onSubmit={handleSubmit}
            actions={[
              <Button
                type="link"
                onClick={() => {
                  setExibirModal(false);
                }}>
                Fechar
              </Button>,
              <FormSubmitButton
                noIcon
                type="primary"
                disabled={!hasPermission(['PRE_SUPRIMENTOS_DEMANDA_SUBSTITUIR_ANEXO'])}>
                <FormatText id="ui.commons.save" uppercase />
              </FormSubmitButton>,
            ]}>
            <Widget>
              <FormInput name="justificativa" label="Justificativa" span={12} required />
              <UploadFile
                nameFormData={'arquivo'}
                label={'Adicionar Arquivo'} 
                hasFile={arquivo} 
                type="primary" 
                idDoComponente={'ModalSubstituirAnexo'} />
            </Widget>
          </MasterDetailForm>
        )}
      </Modal>
    </>
  );
};

export default ModalSubstituirAnexo;
